var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoMaterial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.794,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#10ffa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-material",
    transform: "translate(-1826 -569)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 24,
    height: 24,
    transform: "translate(1826 569)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M-2950-2729a10,10,0,0,1,10-10,10,10,0,0,1,10,10,10,10,0,0,1-10,10A10,10,0,0,1-2950-2729Zm2.223,0a7.787,7.787,0,0,0,7.777,7.778,7.787,7.787,0,0,0,7.778-7.778,7.787,7.787,0,0,0-7.778-7.778A7.786,7.786,0,0,0-2947.777-2729Zm6.56,6.554h0l6.287-10.89a6.71,6.71,0,0,1,.912,1.384l-5.545,9.6c-.145.011-.29.015-.435.015A6.733,6.733,0,0,1-2941.217-2722.446Zm7.8-7.592a6.682,6.682,0,0,1,.08.966v.135a6.679,6.679,0,0,1-.892,3.268,6.678,6.678,0,0,1-3.374,2.888h0Zm-9.919,6.809a6.451,6.451,0,0,1-.621-.406l6.626-11.474a6.565,6.565,0,0,1,1.283.74l-6.625,11.474A6.657,6.657,0,0,1-2943.333-2723.229Zm-2.645-2.82,5.544-9.6c.127-.009.254-.013.381-.014h.107a6.727,6.727,0,0,1,1.167.11l-6.289,10.889A6.7,6.7,0,0,1-2945.978-2726.049Zm-.688-2.882v-.134a6.672,6.672,0,0,1,.893-3.27,6.686,6.686,0,0,1,3.377-2.888l-4.19,7.258A6.679,6.679,0,0,1-2946.667-2728.931Z",
    transform: "translate(4778 3310)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMaterial);
export default __webpack_public_path__ + "static/media/ico-material.d4ab9fa7e1a8178b3e222785de2fb7d1.svg";
export { ForwardRef as ReactComponent };